import { FETCH_CENTRES_CLASSES, FETCH_CENTRES_CLASSES_SUCCESS, FETCH_CENTRES_CLASSES_FAILURE } from '../actions';

const initialState = {
  centers_classes: [],
  loading: true,
  err: null,
  haveData: false
};

export const reducer = (state = initialState, action) => {
  switch(action.type) {
    case FETCH_CENTRES_CLASSES:
      return {
        ...state,
        loading: true,
        err: null,
        haveData: false
      };
    case FETCH_CENTRES_CLASSES_SUCCESS:
      return {
        ...state,
        loading: false,   
        haveData: true,     
        centers_classes: action.data
      };
    case FETCH_CENTRES_CLASSES_FAILURE:
      return {
        ...state,
        loading: false,
        haveData: false,
        err: action.error,
        centers_classes: []
      };
    default:
      return state;
  }
}